<template>
  <div>
    <!-- <router-view v-if="isRouterAlive" /> -->
    <el-dialog
      :visible.sync="$root.loginVisible"
      width="470px"
      :before-close="handleClose"
    >
      <div class="login">
        <div class="box">
          <ul class="tab">
            <li :class="{ on: type == 'code' }" @click="loginType('code')">
              <span>短信登录</span>
            </li>
            <li
              :class="{ on: type == 'password' }"
              @click="loginType('password')"
            >
              <span>密码登录</span>
            </li>
          </ul>

          <div
            class="list"
            :style="{ 'padding-top': isNoRegist ? '70px' : '30px' }"
          >
            <div v-show="isNoRegist" class="register">
              <i class="el-icon-remove" />
              <p>账号未注册，你可以</p>
              <span @click="toRegister">去注册</span>
            </div>
            <el-form :model="loginForm" status-icon>
              <el-form-item v-show="type == 'password'">
                <p class="hint-login">可使用老子云账号登录</p>
                <el-input
                  v-model.trim="loginForm.phone"
                  class="check-inp"
                  name="phone"
                  maxlength="11"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  placeholder="请输入手机号"
                  @focus="accountFocus"
                  @blur="accountBlur"
                >
                  <i
                    slot="prefix"
                    class="iconfont iconzhanghao"
                    ref="pwdMobile"
                  />
                </el-input>
              </el-form-item>

              <el-form-item v-show="type == 'password'" class="hide-check-icon">
                <el-input
                  v-model.trim="loginForm.password"
                  class="check-inp hid-checkicon"
                  maxlength="16"
                  :type="passForm.show.new ? 'text' : 'password'"
                  name="password"
                  autocomplete="off"
                  placeholder="请输入密码"
                  @focus="pwdFocus"
                  @blur="pwdBlur"
                >
                  <i
                    slot="suffix"
                    :class="
                      passForm.show.new
                        ? 'iconfont  iconyulan'
                        : 'iconfont  iconbiyanjing'
                    "
                    ref="confimPwdIcon"
                    @click="showNewPwd"
                  />
                  <i
                    slot="prefix"
                    class="iconfont  iconmima"
                    ref="accountPassword"
                  />
                </el-input>
              </el-form-item>

              <el-form-item v-show="type == 'code'">
                <p class="hint-login">可使用老子云账号登录</p>
                <el-input
                  v-model.trim="loginForm.phone"
                  class="check-inp"
                  maxlength="11"
                  name="phone"
                  placeholder="请输入手机号"
                  @focus="mobileFocus"
                  @blur="mobileBlur"
                >
                  <i
                    slot="prefix"
                    class="iconfont iconzhanghao"
                    ref="account"
                  />
                </el-input>
              </el-form-item>

              <!-- <div class="puzzle" @click="changeTxt">
                <Puzzle :is-reset="isReset" @adopt="adopt" />
              </div> -->

              <sendCode
                ref="sendCode"
                v-model="loginForm.code"
                v-show="type == 'code'"
                :phone="loginForm.phone"
                type="login"
                @getSmsKey="getSmsKey"
                @toAnother="toRegister"
              />
              <!-- <el-form-item v-show="type == 'code'" type="login">
                <el-input
                  v-model="loginForm.code"
                  placeholder="请输入短信验证码"
                  class="code_input"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  maxlength="6"
                  style="width:200px;"
                ></el-input>
                <span
                  class="get_code"
                  @click="sendSysCode('smsUpdatePassword')"
                  >{{ codeButtonText }}</span
                >
              </el-form-item> -->
            </el-form>

            <el-button round class="btn-blue lb" @click="login">登录</el-button>

            <div class="helper">
              <div class="right">
                <span @click="toRebuild">忘记密码？</span>
                <span @click="toRegister">注册账号</span>
              </div>
            </div>
            <thirdLogin></thirdLogin>
          </div>
        </div>
      </div>
    </el-dialog>

    <!---注册协议-->
    <agreement></agreement>
    <!---注册窗口-->
    <register></register>
    <!---修改密码窗口-->
    <pwd-dialog :hintText="true" ref="pwd"></pwd-dialog>
    <!---绑定手机号窗口-->
    <bind-phone></bind-phone>
  </div>
</template>

<script>
import {
  validatePhoneEmail,
  validatePhone,
  validatePwd,
} from "@/utils/validate";
import sendCode from "@/components/sendCode";
import Puzzle from "@/components/aliPuzzle";
import thirdLogin from "@/components/thirdLogin";
import agreement from "@/components/agreement";
import register from "@/components/register";
import pwdDialog from "@/components/getPwd";
import bindPhone from "@/components/bindPhone";
import userInfo from "@/mixins/userInfo";
import { mapMutations, mapState, mapActions } from "vuex";
import BusEvent from '@/busEvent'
import {
  api_userToken,
  api_loginByphone,
  api_send_verificaCode,
} from "@/api/login";
export default {
  mixins: [userInfo],
  components: {
    sendCode,
    Puzzle,
    thirdLogin,
    agreement,
    register,
    pwdDialog,
    bindPhone,
  },

  data() {
    return {
      bthType: false,
      isRouterAlive: true,
      type: "code",
      isNoRegist: false,
      loginForm: {
        phone: "",
        password: "",
        code: "",
      },
      puzzleShow: "",
      pwdRules: {
        phone: [{ validator: validatePhoneEmail, trigger: "blur" }],
        password: [{ validator: validatePwd, trigger: "blur" }],
      },
      // codeRules: {
      //   phone: [{ validator: validatePhone, trigger: 'blur' }],
      //   password: [{ validator: validatePwd, trigger: 'blur' }]
      // },
      verification: false,
      timer: null,
      puzzleTxt: "请进行智能验证",
      isReset: false,
      smsKey: "",
      isPwdShow: "",
      passForm: {
        oldPass: "",
        newPass: "",
        checkPass: "",
        show: {
          old: false,
          new: false,
          check: false,
        },
      },
      codeButtonText: "发送验证码",
      isReady: true,
      showCertification: false,
      userInfoRes: "",
    };
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });

  },
  computed: {
    phoneWatch() {
      return this.loginForm.phone;
    },
  },
  watch: {
    phoneWatch(newVal, oldVal) {
      if (newVal === "") {
        this.isNoRegist = false;
      }
    },
    type: function(n) {
      if (
        n == "code" &&
        this.loginForm.phone &&
        this.loginForm.phone.length > 11
      ) {
        this.loginForm.phone = this.loginForm.phone.substr(0, 11);
      }
    },
    loginForm: {
      handler: function(n) {
        if (n.code) n.code = n.code.replace(/[^\d]/g, "");
        if (n.phone) {
          if (this.type == "password")
            n.phone = n.phone.replace(/[\u4e00-\u9fa5]/, "");
          else n.phone = n.phone.replace(/[^\d]/g, "");
        }
      },
      deep: true,
    },
    // mounted() {
    //   const _this = this;
    // //   document.onkeydown = function(e) {
    // //     const key = window.event.keyCode;
    // //     if (key === 13) {
    // //       _this.login(); //方法
    // //     }
    // //   };
    //   const returnURL =
    //     this.getUrlKey("returnURL") || Cookie.get("returnURL") || "";
    //   if (returnURL) Cookie.set("returnURL", decodeURIComponent(returnURL));

    //   if (this.$route.query.iCode) Cookie.set("iCode", this.$route.query.iCode);
    //   if (this.getUrlKey("iCode")) Cookie.set("iCode", this.$route.query.iCode);

    //   this.isThirdlogin();
    // },
    // beforeDestroy() {
    //   document.onkeydown = function() {
    //     const key = window.event.keyCode;
    //     if (key == 13) {
    //       console.log("13");
    //     }
    //   };
    // },
  },
  methods: {
    async sendSysCode(sysType) {
      if (!this.isReady)
        return this.$message.warning(`请${this.counter}秒后重试`);
      const changePasswParame = {
        type: sysType,
        phone: this.loginForm.phone,
      };
      this.counter = 60;
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.counter > 0) {
          this.counter--;
          this.codeButtonText = `已发送(${this.counter})`;
        } else {
          this.isReady = true;
          clearInterval(this.timer);
        }
      }, 1000);
      const res = await api_send_verificaCode(changePasswParame);
      if (res.resp_code == 60000) {
        this.isReady = false;
        this.smsKey = res.datas;
        this.$message.success({
          showClose: true,
          message: "发送成功",
          type: "success",
        });
      } else {
        this.$message.error(res.resp_msg);
        clearInterval(this.timer);
      }
    },
    //更换密码图标
    showNewPwd() {
      this.passForm.show.new = !this.passForm.show.new;
    },
    ...mapMutations({
      SETTHIRDINFO: "SETTHIRDINFO",
    }),
    handleClose(done) {
       done();
    },
    getUrlKey(name) {
      let url = window.location.href;
      let theRequest = {};
      if (url.indexOf("?") !== -1) {
        let str = url.substr(url.indexOf("?") + 1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
      }

      let str = theRequest[name];

      if (theRequest[name] && theRequest[name].indexOf("#") !== -1) {
        str = theRequest[name].split("#")[0];
      }

      return str ? str : "";
    },

    //密码登录的手机号
    accountFocus() {
      this.$refs.pwdMobile.style.color = "#1458EA";
    },
    accountBlur() {
      this.$refs.pwdMobile.style.color = "#9E9FAB";
    },
    //密码登录
    pwdFocus() {
      this.$refs.accountPassword.style.color = "#1458EA";
    },
    pwdBlur() {
      this.$refs.accountPassword.style.color = "#9E9FAB";
    },
    //短信登录
    mobileFocus() {
      this.$refs.account.style.color = "#1458EA";
    },
    mobileBlur() {
      this.$refs.account.style.color = "#9E9FAB";
    },
    ...mapMutations({
      SETAUTHORIZATION: "login/SETAUTHORIZATION",
      ISLOGINTOASTSHOW: "login/ISLOGINTOASTSHOW",
      SETAGREEMENTPATH: "login/SETAGREEMENTPATH",
      SETREGISTERDATA: "login/SETREGISTERDATA",
    }),
    ...mapActions("login", {
      GETUSERINFO: "GETUSERINFO",
    }),
    changeTxt() {
      this.puzzleTxt = "请进行智能验证";
    },
    adopt() {
      this.verification = true;
      if (this.type == "password") this.loginByPassword();
      if (this.type == "code") this.$refs.sendCode.getCode();
    },
    getSmsKey(val) {
      this.smsKey = val;
    },
    puzzleError() {
      this.verification = false;
    },
    login() {
      if (!this.loginForm.phone) {
        this.$message.error("请输入手机号码");
        return;
      }
      if (this.loginForm.phone.indexOf("@") != -1) {
        if (
          !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
            this.loginForm.phone
          )
        ) {
          this.$message.error("请输入正确的邮箱");
          return;
        }
      } else {
        if (!this.testPhone(this.loginForm.phone)) {
          this.$message.error("请输入正确的手机号");
          return;
        }
      }
      // if (!this.isCodeDend) this.$message.error('请获取验证码')
      if (this.type == "password") this.loginByPassword();
      if (this.type == "code") this.loginByCode();
    },
    async loginByCode() {
      if (!this.smsKey) {
        this.$message.error("请获取验证码");
        return;
      }
      if (!this.loginForm.code) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!/^[0-9]*$/.test(this.loginForm.code)) {
        this.$message.error("请输入正确的验证码");
        return;
      }
      this.regist();
    },
    async loginByPassword() {
      const phone = this.loginForm.phone;
      const password = this.loginForm.password;
      if (!password) {
        this.$message.error("请输入密码");
        return;
      }
      if (password.length < 6 || password.length > 16) {
        this.$message.error("请输入6~16位字符的密码");
        return;
      }
      // if (!this.verification) {
      //   console.log('yanz')
      //   document.getElementById('getCode').click()
      //   return
      // }
      this.bthType = true;
      const res = await api_userToken({
        username: phone,
        password: password,
      });
      if (res.resp_code == 60000) {
        const J = JSON.parse(res.datas);
        this.SETAUTHORIZATION(J.access_token);
        this.GETUSERINFO();
        // this.GETUSERINFO()
        // this.getAppuserinfoTwo(J.access_token,()=>{
        //   this.goReturnUrl()
        // })
        this.$message.success({
          showClose: true,
          message: "登录成功",
          type: "success",
        });
        this.$bus.$emit( BusEvent.LoginSuccess );
        this.$root.loginVisible = false;
        // this.isReset=false;
        // this.reload();
        // setTimeout(() => {
        //   this.goReturnUrl()
        // }, 3000)
      } else if (res.resp_code == 60201) {
        this.isReset = !this.isReset;
        // this.verification = false
        this.bthType = false;
        this.$message.error(res.resp_msg);
      } else if (res.resp_code == 60200) {
        this.isNoRegist = true;
        this.verification = false;
        this.bthType = false;
        this.$message.error(res.resp_msg);
      } else {
        this.verification = false;
        this.bthType = false;
        this.$message.error(res.resp_msg);
      }
    },
    async regist() {
      const _this = this;
      this.bthType = true;
      const obj = {
        phoneno: _this.loginForm.phone,
        verifycode: _this.loginForm.code,
        smsKey: _this.smsKey,
      };

      const res = await api_loginByphone(obj);
      if (res.resp_code == 60000) {
        const J = JSON.parse(res.datas);
        // this.getAppuserinfo(J.access_token)
        this.getAppuserinfoTwo(J.access_token, () => {
            //   this.goReturnUrl();
            this.$message.success({
            showClose: true,
            message: "登录成功",
            type: "success",
            });
            this.$bus.$emit( BusEvent.LoginSuccess );
            this.$root.loginVisible = false;
        });
      } else {
        this.bthType = false;
        this.$message.error(res.resp_msg);
      }
    },
    toRegister() {
      //关闭登录窗口
      this.$root.loginVisible = false;
      //注册协议接口
      this.$root.agreeVisible = true;
      // this.$router.push({
      //       path: '/register'
      //     })
    },
    toRebuild() {
      this.$refs.pwd.isPwdShow = true;
      //关闭登录窗口
      this.$root.loginVisible = false;
    },
    loginType(type) {
      if (type == "code") {
        this.isNoRegist = false;
      }
      this.type = type;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input__inner {
  height: 34px;
  line-height: 34px;
  background-color: #f6f7f8 !important;
  border: none;
}
/deep/ .el-dialog {
  border-radius: 10px;
}
/deep/ .el-dialog__headerbtn {
  top: 30px;
  font-size: 19px;
  right: 58px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #182c49;
  position: relative;
  z-index: 99999;
  font-size: 25px;
}
/deep/ .el-dialog__header {
  padding: 0px;
}
.login {
  position: relative;
  z-index: 9999;
  .el-dialog {
    border-radius: 10px !important;
  }
  .el-dialog__body {
    padding: 35px 20px;
  }
  .hint-login {
    font-size: 12px;
    color: #c0c3c8;
    margin-left: 11px;
    height: 30px;
    line-height: 30px;
  }
}
/deep/.el-button.is-disabled,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-color: #ddd;
  border-color: #ebeef5;
}

.foot-text {
  position: absolute;
  bottom: -35px;
  left: 50px;
  color: #fff;
}

.login {
  //   background: url('../assets/img/bg.png') no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
  .text-wa {
    position: absolute;
    color: #ffffff;
    top: 35%;
    left: 29%;
    line-height: 33px;
  }

  .container-page {
    width: 1180px;
    margin: 0 auto;
  }
  .box {
    background: #fff;
    border-radius: 2px;
    box-sizing: border-box;
    position: relative;
    .helper {
      display: flex;
      justify-content: space-between;
      width: 320px;
      margin-top: 15px;
      font-size: 16px;
      /deep/ .el-checkbox__label {
        color: #0055f3;
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #0055f3;
        border-color: #0055f3;
      }
      /deep/ .el-checkbox {
        vertical-align: middle;
      }
      .right {
        color: #8192a8;
        cursor: pointer;
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        span {
          &:hover {
            color: #0055f3;
          }
        }
      }
    }
    .list {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      padding-top: 90px;
      .icon {
        color: #8192a8;
        font-size: 18px;
      }
      .puzzle {
        user-select: none;
        position: absolute;
        top: 193px;
        // margin-bottom: 20px;
      }
      .lb {
        width: 320px;
        height: 50px;
        border-radius: 40px;
        margin-left: 0;
        margin-top: 20px;
        /deep/ span {
          font-size: 16px;
        }
      }

      .login-btn {
        width: 320px;
        height: 60px;
        border-radius: 40px;
        background-color: #0055f3;
        color: #fff;
        text-align: center;
        line-height: 60px;
        margin-top: 25px;
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 85, 243, 0.12);
        }
        span {
          text-align: center;
          font-size: 16px;
        }
      }
      .register {
        position: absolute;
        top: 255px;
        display: flex;
        align-items: center;
        border: solid 1px #ffbb8e;
        background-color: rgba(245, 82, 49, 0.12);
        height: 30px;
        width: 308px;
        border-radius: 4px;
        padding-left: 10px;
        p {
          color: #8192a8;
          font-size: 12px;
        }
        span {
          color: #ff1616;
          font-size: 12px;
          cursor: pointer;
        }
        i {
          color: #ff1616;
        }
      }
      .block {
        width: 340px;
        margin-left: 40px;
      }
      .tit {
        margin-right: 10px;
      }
    }
    .tab {
      text-align: center;
      margin: 0 40px;
      border-bottom: 1px solid #e6e9f0;
      li:first-child {
        // margin-right: 50px;
      }
      li {
        cursor: pointer;
        color: #132c4b;
        font-size: 20px;
        padding-bottom: 20px;
        border-bottom: 4px solid transparent;
        white-space: nowrap;
        display: inline-block;
        margin-left: 23px;
        position: relative;
        &:nth-child(1) {
          &::after {
            display: inline-block;
            content: "";
            width: 1px;
            height: 11px;
            background: #8b8b8b;
            position: absolute;
            right: 6px;
            top: 10px;
          }
        }
        span {
          font-size: 14px;
          display: block;
          transform: translate(-18px);
        }
      }
      .on {
        color: #1458ea;
        font-weight: 800;
        span {
          font-size: 20px;
        }
      }
    }
  }
}
.check-inp {
  width: 320px;
}

.code-inp {
  width: 200px;
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
/deep/.el-input__inner {
  background-color: #ffffff;
}
.hide-check-icon {
  /deep/.el-input__suffix {
    /deep/.el-input__validateIcon {
      display: none;
    }
  }
}
.btn-blue {
  background: #1458ea;
  border: none;
  color: #ffffff;
  transition: all 0.2s linear;
}

.btn-blue:focus,
.btn-blue:hover {
  color: #ffffff;
  border-color: #1458ea;
  background-color: rgba(20, 88, 234, 0.8);
}

/deep/.el-input__inner:focus {
  color: #1458ea;
  border-color: #1458ea;
}
/deep/ .el-input__prefix:focus {
  color: #1458ea;
}
/deep/.el-input__prefix {
  left: 17px;
  top: 1px;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 40px;
}
/deep/ .el-input__suffix {
  right: 20px;
}
</style>
<style>
.code_input {
  width: 200px;
}
.get_code {
  margin-left: 20px;
  cursor: pointer;
  color: #1458ea;
}
</style>
